<div class="cards-row">
	<mat-card class="system-card">
		<mat-card-header>
			<div class="card-header-row">
				<mat-card-title>Podstawa (Gratyfikant)</mat-card-title>
				<div class="load-action">
					@if (state.gratyfikantLoadedAt()) {
						<span class="loaded-at"
							>Ostatnio: {{ state.gratyfikantLoadedAt() | date: 'd MMM yyyy, HH:mm' }}</span
						>
					}
					<span
						[matTooltip]="state.gratyfikantTooltip()"
						[matTooltipDisabled]="!state.gratyfikantTooltip()"
						matTooltipPosition="above"
					>
						<button
							mat-raised-button
							color="primary"
							(click)="state.loadGratyfikant()"
							[disabled]="state.gratyfikantDisabled()"
						>
							@if (state.gratyfikantLoading()) {
								<mat-spinner
									diameter="18"
									class="me-2 d-inline-block"
									style="--mdc-circular-progress-active-indicator-color: #fff"
								></mat-spinner>
							}
							Ściągnij dane
						</button>
					</span>
				</div>
			</div>
		</mat-card-header>
		<mat-card-content>
			@if (state.gratyfikantError()) {
				<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
					<i class="fa-solid fa-triangle-exclamation me-2"></i>
					<div><strong>Błąd:</strong> {{ state.gratyfikantError() }}</div>
				</div>
			}
			@if (state.gratyfikantSkipped().length > 0) {
				<div class="alert alert-warning d-flex align-items-start mb-3" role="alert">
					<i class="fa-solid fa-circle-info me-2 mt-1"></i>
					<div>
						<strong>Pominięto {{ state.gratyfikantSkipped().length }} organizacj(e):</strong>
						<ul class="mb-0 mt-1 ps-3">
							@for (skipped of state.gratyfikantSkipped(); track skipped.organization_id) {
								<li>
									{{ skipped.organization_name }} —
									@if (skipped.reason === 'no_db') {
										brak skonfigurowanej bazy Gratyfikant
									} @else if (skipped.reason === 'fetch_failed') {
										błąd połączenia z bazą Gratyfikant
										@if (skipped.error) {
											<span class="text-muted">({{ skipped.error }})</span>
										}
									}
								</li>
							}
						</ul>
					</div>
				</div>
			}
			<mat-form-field appearance="outline">
				<mat-label>Netto</mat-label>
				<input
					matInput
					[value]="state.gratyfikantLoaded() ? (state.gratyfikantTotal() | priceFormat) : ''"
					readonly
				/>
			</mat-form-field>
		</mat-card-content>
	</mat-card>

	<mat-card class="system-card">
		<mat-card-header>
			<div class="card-header-row">
				<mat-card-title>Dieta (Enova)</mat-card-title>
				<div class="load-action">
					@if (state.enovaLoadedAt()) {
						<span class="loaded-at">Ostatnio: {{ state.enovaLoadedAt() | date: 'd MMM yyyy, HH:mm' }}</span>
					}
					<span
						[matTooltip]="state.enovaTooltip()"
						[matTooltipDisabled]="!state.enovaTooltip()"
						matTooltipPosition="above"
					>
						<button
							mat-raised-button
							color="primary"
							(click)="state.loadEnova()"
							[disabled]="state.enovaDisabled()"
						>
							@if (state.enovaLoading()) {
								<mat-spinner
									diameter="18"
									class="me-2 d-inline-block"
									style="--mdc-circular-progress-active-indicator-color: #fff"
								></mat-spinner>
							}
							Ściągnij dane
						</button>
					</span>
				</div>
			</div>
		</mat-card-header>
		<mat-card-content>
			@if (state.enovaError()) {
				<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
					<i class="fa-solid fa-triangle-exclamation me-2"></i>
					<div><strong>Błąd:</strong> {{ state.enovaError() }}</div>
				</div>
			}
			<mat-form-field appearance="outline">
				<mat-label>Netto</mat-label>
				<input matInput [value]="state.enovaLoaded() ? (state.enovaTotal() | priceFormat) : ''" readonly />
			</mat-form-field>
		</mat-card-content>
	</mat-card>
</div>

<mat-card class="system-card">
	<mat-card-header>
		<div class="card-header-row">
			<mat-card-title>Nawigator</mat-card-title>
			<div class="load-action">
				@if (state.nawigatorLoadedAt()) {
					<span class="loaded-at">Ostatnio: {{ state.nawigatorLoadedAt() | date: 'd MMM yyyy, HH:mm' }}</span>
				}
				<span
					[matTooltip]="state.nawigatorTooltip()"
					[matTooltipDisabled]="!state.nawigatorTooltip()"
					matTooltipPosition="above"
				>
					<button
						mat-raised-button
						color="primary"
						(click)="state.loadNawigator()"
						[disabled]="state.nawigatorDisabled()"
					>
						@if (state.nawigatorLoading()) {
							<mat-spinner
								diameter="18"
								class="me-2 d-inline-block"
								style="--mdc-circular-progress-active-indicator-color: #fff"
							></mat-spinner>
						}
						Ściągnij dane
					</button>
				</span>
			</div>
		</div>
	</mat-card-header>
	<mat-card-content>
		@if (state.nawigatorError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="fa-solid fa-triangle-exclamation me-2"></i>
				<div><strong>Błąd:</strong> {{ state.nawigatorError() }}</div>
			</div>
		}
		@if (state.nawigatorPullStats(); as stats) {
			@if (stats.skipped_no_driver.length > 0 || stats.errors > 0) {
				<div class="alert alert-warning d-flex align-items-start mb-3" role="alert">
					<i class="fa-solid fa-triangle-exclamation me-2 mt-1"></i>
					<div>
						<strong>Ostrzeżenie:</strong>
						@if (stats.skipped_no_driver.length > 0) {
							pominięto {{ stats.skipped_no_driver.length }} zdarzeń bez kierowcy w Oskar.
						}
						@if (stats.errors > 0) {
							{{ stats.errors }} zdarzeń zakończyło się błędem.
						}
					</div>
				</div>
			}
		}
		@if (state.eventExclusionError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="fa-solid fa-triangle-exclamation me-2"></i>
				<div><strong>Błąd:</strong> {{ state.eventExclusionError() }}</div>
			</div>
		}
		<mat-accordion multi>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						@if (state.tourismEventsLoading()) {
							<mat-spinner diameter="16" class="me-2 d-inline-block"></mat-spinner>
						}
						Praca w miesiącu ({{ state.pracaEvents().length }})
						@if (state.isMonthlyBase()) {
							<span class="praca-total">· {{ state.monthlyBaseAmount() | priceCurrency: 'PLN' }}</span>
						} @else if (state.pracaTotal() !== null) {
							<span
								class="praca-total"
								[class.praca-total--fallback]="state.pracaUsesFallbackRate()"
								[title]="
									state.pracaUsesFallbackRate()
										? 'Domyślna stawka 400 PLN — kierowca bez skonfigurowanej stawki jezdnej'
										: ''
								"
							>
								· {{ state.pracaTotal() | priceCurrency: 'PLN' }}
							</span>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.isMonthlyBase()) {
					<div class="alert alert-info d-flex align-items-center mb-0" role="alert">
						<i class="fa-solid fa-circle-info me-2"></i>
						<div>
							Wynagrodzenie za ten miesiąc rozliczane jako <strong>wypłata miesięczna</strong>:
							<strong>{{ state.monthlyBaseAmount() | priceCurrency: 'PLN' }}</strong
							>. Dniówka (stawka × dni Praca) nie jest naliczana w tym miesiącu.
						</div>
					</div>
				} @else {
					@if (state.pracaUsesFallbackRate()) {
						<div class="praca-fallback-alert" role="alert">
							<i
								class="fa-solid fa-triangle-exclamation praca-fallback-alert__icon"
								aria-hidden="true"
							></i>
							<span>
								Brak skonfigurowanej stawki jezdnej dla tego kierowcy. Naliczamy domyślne
								<strong>400 PLN/dniówka</strong>. Skonfiguruj stawkę w zakładce <strong>Stawki</strong>.
							</span>
						</div>
					}
					@if (state.pracaEvents().length > 0) {
						<div class="tourism-events-list">
							@for (row of state.pracaEvents(); track row.id) {
								<app-salary-tourism-event-row
									[eventId]="row.id"
									[dateFrom]="row.dateFrom"
									[dateTo]="row.dateTo"
									[excluded]="row.excluded"
									[comment]="row.comment"
									[disabled]="state.isSettled()"
								>
									@if (state.activeWorkRate() !== null) {
										({{ row.daysInMonth }} dni ×
										{{ state.activeWorkRate() | priceCurrency: 'PLN' }} =
										<strong>{{ row.amount | priceCurrency: 'PLN' }}</strong
										>)
									} @else {
										({{ row.daysInMonth }} dni ×
										{{ pracaFallbackRateGrosze | priceCurrency: 'PLN' }} =
										<strong>{{ row.amount | priceCurrency: 'PLN' }}</strong> —
										<em>domyślna stawka</em>)
									}
								</app-salary-tourism-event-row>
							}
						</div>
					} @else if (!state.tourismEventsLoading()) {
						<p class="empty-state">Brak zdarzeń typu Praca dla tego kierowcy w wybranym miesiącu.</p>
					}
				}
			</mat-expansion-panel>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						@if (state.tourismEventsLoading()) {
							<mat-spinner diameter="16" class="me-2 d-inline-block"></mat-spinner>
						}
						Techniczny w miesiącu ({{ state.technicznyEvents().length }})
						@if (state.technicznyTotal() !== null) {
							<span class="praca-total">· {{ state.technicznyTotal() | priceCurrency: 'PLN' }}</span>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.technicznyEvents().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.technicznyEvents(); track row.id) {
							<app-salary-tourism-event-row
								[eventId]="row.id"
								[dateFrom]="row.dateFrom"
								[dateTo]="row.dateTo"
								[excluded]="row.excluded"
								[comment]="row.comment"
								[disabled]="state.isSettled()"
							>
								(ryczałt <strong>{{ row.amount | priceCurrency: 'PLN' }}</strong
								>)
							</app-salary-tourism-event-row>
						}
					</div>
				} @else if (!state.tourismEventsLoading()) {
					<p class="empty-state">Brak zdarzeń typu Techniczny dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						@if (state.tourismEventsLoading()) {
							<mat-spinner diameter="16" class="me-2 d-inline-block"></mat-spinner>
						}
						Dojazd w miesiącu ({{ state.dojazdEvents().length }})
						@if (state.dojazdTotal() !== null) {
							<span class="praca-total">· {{ state.dojazdTotal() | priceCurrency: 'PLN' }}</span>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.dojazdEvents().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.dojazdEvents(); track row.id) {
							<app-salary-tourism-event-row
								[eventId]="row.id"
								[dateFrom]="row.dateFrom"
								[dateTo]="row.dateTo"
								[excluded]="row.excluded"
								[comment]="row.comment"
								[disabled]="state.isSettled()"
							>
								(ryczałt <strong>{{ row.amount | priceCurrency: 'PLN' }}</strong
								>)
							</app-salary-tourism-event-row>
						}
					</div>
				} @else if (!state.tourismEventsLoading()) {
					<p class="empty-state">Brak zdarzeń typu Dojazd dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
		</mat-accordion>
	</mat-card-content>
</mat-card>
